export const serverUrl = 'https://australia-southeast1-managd-au.cloudfunctions.net/'
// export const serverUrl = 'http://127.0.0.1:5001/managd-au/australia-southeast1/'

export const googleApiKey = 'AIzaSyBYqC6pgygdvrpJ3IG9_X9otm1xFAIzG7o'

export const TrafficClassOptions = [
    'Traffic Controller',
    'Implement Traffic Control Plans',
    'Prepare A Work Zone Traffic Management Plan'
]

export const HighRiskClassOptions = [
    'Forklift',
    'Hoist',
    'Dogging',
    'Rigging',
    'Crane',
    'Scaffold'
]

export const ContractorClassOptions = [
    "Bricklaying",
    "Carpentry",
    "Decorating",
    "Dry plastering",
    "Excavating",
    "Fencing",
    "General concreting",
    "Glazing",
    "Joinery",
    "Metal fabrication",
    "Minor maintenance and cleaning",
    "Minor trade work",
    "Painting",
    "Roof plumbing",
    "Roof slating",
    "Roof tiling",
    "Stonemasonry",
    "Swimming pool repairs and servicing",
    "Wall and floor tiling",
    "Waterproofing",
    "Wet plastering"
]


export const equipmentOptions = ['Work ute', 'Traffic light', 'Boom gate', 'Traffic Ute']

export const workerStatuses = ['Created', 'Pending Review', 'Approved']
export const workerTypes = ['Traffic Controller', 'General Labourer', 'Skilled Labourer', 'Skilled Worker A', 'Skilled Worker B']
export const userTypes = ['Employee', 'Contractor']

// Start of the current day, in local time.
export const getStartOfToday = () => {
    const date = new Date()
    date.setHours(0, 0, 0, 0)
    return date
}
